import React from "react"
import {FieldViewSize} from "../../../../../const";

export default function FieldSelectView_FormValueNotEmpty(props:any) {

    const size = _.get(props, 'size', FieldViewSize.DEFAULT)
    const valueClasses = Classes("ui5-txt-default ui5-field-form-editable light-border gray-bg dropdown-form no-wrap", props.className, {
        'h-36'  : size === FieldViewSize.DEFAULT,
        'h-28'  : size === FieldViewSize.SMALL,
    })

    const selectedView = _.find(props.field.views, view=>view.id === props.value)

    const renderIcon = ()=> {

        if (selectedView?.icon?.startsWith("isvg")) {
            return <div className={Classes('w-15 h-15 m-r-8', selectedView?.icon)}/>
        } else {
            return <div className={Classes('ui5-ico-15 m-r-8', selectedView?.icon)}/>
        }
    }

    return (
        <>
            <div className={valueClasses} onClick={props.onClick}>

                {renderIcon()}

                <span className="txt-truncate">{selectedView?.name}</span>
            </div>
            {props.children}
        </>
    );
}
